
<form [nbSpinner]="loading"
nbSpinnerStatus="danger"
nbSpinnerSize="large"
nbSpinnerMessage="Guardando usuario...">
<div class="row">
<div class="col-md-12">
  <nb-card>
    <nb-card-header>
      <nav class="navbar navigation">
        <span><nb-icon icon="globe"></nb-icon> Datos del framelink - {{framelinkdata.name}}</span>
        <button nbButton status="primary" (click)="back()"><nb-icon icon="arrow-back"></nb-icon>
        </button>

      </nav>

    </nb-card-header>

    <nb-card-body>
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group">
            <label for="nombre" class="label">Nombre</label>
            <input type="text" nbInput fullWidth id="nombre" name="nombre" [(ngModel)]="framelinkdata.name"/>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="category" class="label">Tipo</label><br/>
            <nb-select placeholder="Tipo de Card-Link" fullWidth name="role" [(ngModel)]="framelinkdata.category">
              <nb-option [value]="item" *ngFor="let item of categoryOptions">{{item}}</nb-option>
            </nb-select>

          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="subcategory" class="label">Categoría en menú</label>
            <input type="text" nbInput fullWidth id="subcategory" name="subcategory" [(ngModel)]="framelinkdata.subcategory"/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4">

            <ngx-icon-selector [(icon)]="framelinkdata.icon"></ngx-icon-selector>
          </div>

        <div class="col-sm-8">
          <div class="form-group">
            <label for="link" class="label">Link</label>
            <input type="text" nbInput fullWidth id="link" placeholder="http://www.dominio.com/algo" name="link" [(ngModel)]="framelinkdata.link">
          </div>
        </div>

      </div>



    </nb-card-body>
  </nb-card>
</div>



</div>
<div class="row">
  <div class="col-md-12">
    <button nbButton fullWidth status="primary" (click)="guardar()" ><nb-icon icon="save"></nb-icon>Guardar</button>
  </div>

</div>
</form>

